"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Icons_1 = require("../Icons");
var Text_1 = require("../Text/Text");
var styled_components_1 = __importDefault(require("styled-components"));
var LiveInfoBadge = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.liveText, liveText = _b === void 0 ? 'LIVE' : _b, pause = _a.pause, _c = _a.pauseText, pauseText = _c === void 0 ? 'PAUSED' : _c, _d = _a.testid, testid = _d === void 0 ? 'liveInfoBadge' : _d, video = _a.video;
    return (React.createElement(StyledBadge, { className: className, "data-testid": testid },
        pause ? React.createElement(StyledPauseIconSmall, { color: "white" }) : video && React.createElement(StyledVideoCameraIcon, { color: "white" }),
        pause ? pauseText : liveText,
        React.createElement(StyledEyeIcon, { color: "white" }),
        children || '1'));
};
exports.default = LiveInfoBadge;
var StyledBadge = (0, styled_components_1.default)(Text_1.H6)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    /* ensure that we override the H6 styles */\n    && {\n        z-index: 2;\n        padding: 0 8px;\n        height: 22px;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 1px;\n        background-color: ", ";\n        color: ", ";\n    }\n"], ["\n    /* ensure that we override the H6 styles */\n    && {\n        z-index: 2;\n        padding: 0 8px;\n        height: 22px;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 1px;\n        background-color: ", ";\n        color: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
});
var StyledVideoCameraIcon = (0, styled_components_1.default)(Icons_1.VideoCameraIconSmall)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0 6px 0 0;\n"], ["\n    margin: 0 6px 0 0;\n"])));
var StyledEyeIcon = (0, styled_components_1.default)(Icons_1.EyeIconSmall)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 6px;\n"], ["\n    margin: 0 6px;\n"])));
var StyledPauseIconSmall = (0, styled_components_1.default)(Icons_1.PauseIconSmall)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    && {\n        margin: 0 6px 0 0;\n    }\n"], ["\n    && {\n        margin: 0 6px 0 0;\n    }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
